import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useCompanyStore } from 'stores';
// no results picture
import no_results from 'assets/img/no_results.png';

const NoResults = ({ text = '', icon = null, className = '', showBackToHome = false }) => {
  const { t } = useTranslation(['backoffice']);
  const { name } = useCompanyStore();
  return (
    <Row className={`text-center mt-4 w-100 ${className}`}>
      <Col lg={12} className="margin-bottom-md mt-5">
        {icon ? <img src={icon} alt='No results' /> : <img src={no_results} alt='No results' />}
      </Col>
      <Col lg={12} className="margin-bottom-md">
        <h2>{text !== '' ? <p>{text}</p> : <p>{t('noresults')}</p>}</h2>
        {showBackToHome && <>
          <p>
            {t('accesshomepage', { ns: 'home' })}
            <Link to="/" className="">{' '}{name}</Link>
          </p>
          <Link to="/" className="">
            <Button className="mt-4 py-3 px-5">{t('gobackhome', { ns: 'home' }).toUpperCase()}</Button>
          </Link>
        </>}
      </Col>
    </Row>
  );
};

NoResults.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.any,
  className: PropTypes.string,
  showBackToHome: PropTypes.bool
};

export default NoResults;
